import * as URLConfig from "@frameworks/web/config/domain";
const config = URLConfig.config;
const appEwinConstant = "app-ewin/home/";
const configURL = {
    market: {
        status: config.jmw + config.jmw_content + "bull",
        root: config.web_mw + "Market/Process/",
        market: config.web_mw + "Market/",
    },
    streamUrl: config.streamUrl,
    home: config.jmw + config.jmw_market_env + appEwinConstant,
    newOnEdel: config.jmw + config.jmw_market_env + appEwinConstant + "new-on-edel",
    liveNewsUrl: config.jmw + config.jmw_content + "liveNews/general",
    liveNewsNFOUrl: config.jmw + config.jmw_content + "liveNews",
    marketNewsUrl: config.jmw + config.jmw_news_content + "news/trendlyne/allNews",
    appid: config.appId,
    rootUrl: config.rootUrl,
    equityHoldingLiveNews: config.jmw + config.eqedel + "news/eqholdings",
};
const urlConfig = Object.assign({}, configURL);
export default urlConfig;
